import EnglishPage from "@/pages/contact";
import I18nProvider from "@/components/I18nProvider";

// Hindi route for /contact. Reuses the English page component untouched —
// Layout walks its JSX tree and swaps text via the translation memory, so the
// copy lives in exactly one place.
export default function HindiPage() {
  return (
    <I18nProvider locale="hi">
      <EnglishPage />
    </I18nProvider>
  );
}
